import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/landing/page/bioderma_galchonok/src/lib/FeatureLandingPageBiodermaGalchonok.tsx");
